// removed by extract-text-webpack-plugin
module.exports = {"loader":"_1UEtE","load7":"_1kT7H"};


//////////////////
// WEBPACK FOOTER
// ./app/components/typing-list-loader/typing-list-loader.scss
// module id = 1739
// module chunks = 0